// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"ba38fa612f5ffc1942f8","293":"1fb8e0e5161d62e65441","518":"60b1ce6e93dfe8a332a1","779":"da2457509500d7f49e1e"}[chunkId] + ".js";
};